import defaultClient from '@src/api/clients/default';

function buildPreviewParams({
  clientId,
  verticalIds = [],
  territoryIds = [],
  includeFilteredOut = false,
  sampleSize = 20,
  includeZipCodes = false,
}) {
  const params = {
    client_id: clientId,
    include_filtered_out: includeFilteredOut ? 'true' : 'false',
    sample_size: sampleSize,
  };

  if (verticalIds.length) {
    params.vertical_ids = verticalIds.join(',');
  }
  if (territoryIds.length) {
    params.territory_ids = territoryIds.join(',');
  }
  if (includeZipCodes) {
    params.include_zip_codes = 'true';
  }

  return params;
}

export function previewFacebookZipTargeting({
  clientId,
  verticalIds = [],
  territoryIds = [],
  includeFilteredOut = false,
  sampleSize = 20,
  includeZipCodes = false,
}) {
  return defaultClient.request({
    url: 'dashboard/facebook/zip-targeting/preview/',
    method: 'GET',
    options: {
      params: buildPreviewParams({
        clientId,
        verticalIds,
        territoryIds,
        includeFilteredOut,
        sampleSize,
        includeZipCodes,
      }),
    },
  });
}

export function pushFacebookZipTargeting(payload) {
  return defaultClient.request({
    url: 'dashboard/facebook/zip-targeting/push/',
    method: 'POST',
    payload,
  });
}

export function fetchFacebookAdSetTargeting({
  clientId,
  adAccountId,
  adSetId,
}) {
  return defaultClient.request({
    url: 'dashboard/facebook/zip-targeting/adset-targeting/',
    method: 'GET',
    options: {
      params: {
        client_id: clientId,
        ad_account_id: adAccountId,
        ad_set_id: adSetId,
      },
    },
  });
}

export function fetchFacebookZipPushLog({
  clientId,
  adAccountId,
  adSetId,
  limit = 25,
}) {
  const params = {
    client_id: clientId,
    limit,
  };
  if (adAccountId) {
    params.ad_account_id = adAccountId;
  }
  if (adSetId) {
    params.ad_set_id = adSetId;
  }
  return defaultClient.request({
    url: 'dashboard/facebook/zip-targeting/push-log/',
    method: 'GET',
    options: {
      params,
    },
  });
}

export function fetchFacebookValueRulesPreview({
  clientId,
  campaignIds = [],
  verticalIds = [],
  territoryIds = [],
  lookbackDays = 30,
  minDmaLeads = 8,
  minCityLeads = 12,
  pacingTolerancePct = 15,
}) {
  const params = {
    client_id: clientId,
    lookback_days: lookbackDays,
    min_dma_leads: minDmaLeads,
    min_city_leads: minCityLeads,
    pacing_tolerance_pct: pacingTolerancePct,
  };
  if (campaignIds.length) {
    params.campaign_ids = campaignIds.join(',');
  }
  if (verticalIds.length) {
    params.vertical_ids = verticalIds.join(',');
  }
  if (territoryIds.length) {
    params.territory_ids = territoryIds.join(',');
  }

  return defaultClient.request({
    url: 'dashboard/facebook/value-rules/preview/',
    method: 'GET',
    options: {
      params,
    },
  });
}

export function fetchFacebookZipPushHistory({ clientId, adSetId, limit = 25 }) {
  const params = { client_id: clientId, limit };
  if (adSetId) {
    params.ad_set_id = adSetId;
  }
  return defaultClient.request({
    url: 'dashboard/facebook/zip-targeting/push-history/',
    method: 'GET',
    options: { params },
  });
}

export function fetchFacebookZipPreviewMap({
  clientId,
  verticalIds = [],
  territoryIds = [],
  includeFilteredOut = false,
  zips = null,
  includeGeometry = false,
}) {
  const params = { client_id: clientId };
  if (includeGeometry) {
    params.include_geometry = 'true';
  }
  if (zips && zips.length) {
    params.zips = zips.join(',');
  } else {
    params.include_filtered_out = includeFilteredOut ? 'true' : 'false';
    if (verticalIds.length) {
      params.vertical_ids = verticalIds.join(',');
    }
    if (territoryIds.length) {
      params.territory_ids = territoryIds.join(',');
    }
  }
  return defaultClient.request({
    url: 'dashboard/facebook/zip-targeting/preview-map/',
    method: 'GET',
    options: { params },
  });
}
